import type { MediaItemInterface } from '@hypercodestudio/basler-components';

import type { ComponentPublicInstance, Ref } from 'vue';
import { useProgressiveMediaOverlay } from '~/composables/useProgressiveMediaOverlay';
import {
  heroImagePreviewQuality,
  heroImagePreviewWidth
} from '~/components/global/constants';

/**
 * Keeps the blur-up hero preview as an overlay while rendering the real image for LCP discovery.
 */
export function useProgressiveHeroMedia(
  baseMedia: MediaItemInterface | undefined,
  root: Ref<ComponentPublicInstance | undefined>
) {
  return useProgressiveMediaOverlay(baseMedia, {
    root,
    previewWidth: heroImagePreviewWidth,
    previewQuality: heroImagePreviewQuality,
    preloadHighResInHead: true,
    preloadKey: 'hero-image'
  });
}
